export default __webpack_public_path__ + "267a71578140f0dd6e58dd9a16baf1f9.png";